/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfRegionName } from '../models';
// @ts-ignore
import type { BfSearchResult } from '../models';
// @ts-ignore
import type { BfSourceProcess } from '../models';
// @ts-ignore
import type { FeatureBfFlightSimple } from '../models';
// @ts-ignore
import type { FeatureCollectionBfEvent } from '../models';
// @ts-ignore
import type { FeatureCollectionBfFireDanger } from '../models';
// @ts-ignore
import type { FeatureCollectionBfFlight } from '../models';
// @ts-ignore
import type { FeatureCollectionBfHotspot } from '../models';
// @ts-ignore
import type { FeatureCollectionBfIgnition } from '../models';
// @ts-ignore
import type { FeatureCollectionBfLightning } from '../models';
// @ts-ignore
import type { FeatureCollectionBfMedia } from '../models';
// @ts-ignore
import type { FeatureCollectionBfRoad } from '../models';
// @ts-ignore
import type { FeatureCollectionBfWeatherObservation } from '../models';
/**
 * DataApi - axios parameter creator
 */
export const DataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get ADSB
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdsb: async (region: BfRegionName, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getAdsb', 'region', region)
            const localVarPath = `/v1/data/{region}/adsb`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a track for a flight.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get ADSB track
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdsbFlight: async (eKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('getAdsbFlight', 'eKey', eKey)
            const localVarPath = `/v1/data/adsb/{e_key}`
                .replace(`{${"e_key"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve automated satellite fire detections and their linked burn areas. These events are excluded from `/warnings` by default.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get satellite detections
         * @param {BfRegionName} region Region name
         * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
         * @param {boolean} [simple] Only return simple events
         * @param {boolean} [points] If true, only return points (or centroids)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetections: async (region: BfRegionName, period?: string, simple?: boolean, points?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getDetections', 'region', region)
            const localVarPath = `/v1/data/{region}/detections`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = (period as any instanceof Date) ?
                    (period as any).toISOString() :
                    period;
            }

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            if (points !== undefined) {
                localVarQueryParameter['points'] = points;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch fire danger ratings and total fire ban notifications.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get fire danger and TOBANs
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFireDanger: async (region: BfRegionName, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getFireDanger', 'region', region)
            const localVarPath = `/v1/data/{region}/firedanger`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get hotspots
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHotspots: async (region: BfRegionName, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getHotspots', 'region', region)
            const localVarPath = `/v1/data/{region}/hotspots`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch when a fire has likely been ignited.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get fire ignition events
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIgnitions: async (region: BfRegionName, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getIgnitions', 'region', region)
            const localVarPath = `/v1/data/{region}/ignitions`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get Lightning
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {number} [hours] Hours of strikes to return, 1 to 24; defaults to 3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLightning: async (region: BfRegionName, simple?: boolean, hours?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getLightning', 'region', region)
            const localVarPath = `/v1/data/{region}/lightning`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            if (hours !== undefined) {
                localVarQueryParameter['hours'] = hours;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve media asserts.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get media
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedia: async (region: BfRegionName, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getMedia', 'region', region)
            const localVarPath = `/v1/data/{region}/media`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get roads
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoads: async (region: BfRegionName, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getRoads', 'region', region)
            const localVarPath = `/v1/data/{region}/roads`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Time Machine artifacts
         * @param {string} artifact 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeMachineArtifact: async (artifact: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artifact' is not null or undefined
            assertParamExists('getTimeMachineArtifact', 'artifact', artifact)
            const localVarPath = `/v1/data/archive/{artifact}`
                .replace(`{${"artifact"}}`, encodeURIComponent(String(artifact)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get wind forecast
         * @param {BfRegionName} region Region name
         * @param {BfSourceProcess} sourceProcess Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVelocityForecast: async (region: BfRegionName, sourceProcess: BfSourceProcess, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getVelocityForecast', 'region', region)
            // verify required parameter 'sourceProcess' is not null or undefined
            assertParamExists('getVelocityForecast', 'sourceProcess', sourceProcess)
            const localVarPath = `/v1/data/{region}/velocity/model/{source_process}`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)))
                .replace(`{${"source_process"}}`, encodeURIComponent(String(sourceProcess)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get warnings
         * @param {BfRegionName} region Region name
         * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
         * @param {boolean} [simple] Only return simple events
         * @param {string} [definition] Events matching this Notification ID will be returned
         * @param {boolean} [points] If true, only return points (or centroids)
         * @param {boolean} [satelliteDetections] If true, include automated satellite fire detections; defaults to false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarningsIncidents: async (region: BfRegionName, period?: string, simple?: boolean, definition?: string, points?: boolean, satelliteDetections?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getWarningsIncidents', 'region', region)
            const localVarPath = `/v1/data/{region}/warnings`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = (period as any instanceof Date) ?
                    (period as any).toISOString() :
                    period;
            }

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            if (definition !== undefined) {
                localVarQueryParameter['definition'] = definition;
            }

            if (points !== undefined) {
                localVarQueryParameter['points'] = points;
            }

            if (satelliteDetections !== undefined) {
                localVarQueryParameter['satelliteDetections'] = satelliteDetections;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get weather
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeather: async (region: BfRegionName, simple?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getWeather', 'region', region)
            const localVarPath = `/v1/data/{region}/weather`
                .replace(`{${"region"}}`, encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (simple !== undefined) {
                localVarQueryParameter['simple'] = simple;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A generic search endpoint which can return warnings, incidents, locations, and users.
         * @summary Search
         * @param {string} query Search query
         * @param {BfRegionName} [region] Region name
         * @param {number} [lat] Proximity latitude
         * @param {number} [lon] Proximity longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (query: string, region?: BfRegionName, lat?: number, lon?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('search', 'query', query)
            const localVarPath = `/v1/data/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lon !== undefined) {
                localVarQueryParameter['lon'] = lon;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search warnings and incidents
         * @param {string} query Search query
         * @param {BfRegionName} [region] Region name
         * @param {number} [lat] Proximity latitude
         * @param {number} [lon] Proximity longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsIncidents: async (query: string, region?: BfRegionName, lat?: number, lon?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchWarningsIncidents', 'query', query)
            const localVarPath = `/v1/data/warnings/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lon !== undefined) {
                localVarQueryParameter['lon'] = lon;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload wind data
         * @param {BfSourceProcess} sourceProcess Source process for the wind data
         * @param {File} file File to upload
         * @param {string | null} [orgId] Organisation ID, the icon will be associated with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWind: async (sourceProcess: BfSourceProcess, file: File, orgId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceProcess' is not null or undefined
            assertParamExists('uploadWind', 'sourceProcess', sourceProcess)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadWind', 'file', file)
            const localVarPath = `/v1/event/wind/{source_process}`
                .replace(`{${"source_process"}}`, encodeURIComponent(String(sourceProcess)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (orgId !== undefined) { 
                localVarFormParams.append('org_id', orgId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataApi - functional programming interface
 */
export const DataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get ADSB
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdsb(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfFlight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdsb(region, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getAdsb']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a track for a flight.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get ADSB track
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdsbFlight(eKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureBfFlightSimple>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdsbFlight(eKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getAdsbFlight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve automated satellite fire detections and their linked burn areas. These events are excluded from `/warnings` by default.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get satellite detections
         * @param {BfRegionName} region Region name
         * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
         * @param {boolean} [simple] Only return simple events
         * @param {boolean} [points] If true, only return points (or centroids)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetections(region: BfRegionName, period?: string, simple?: boolean, points?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetections(region, period, simple, points, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getDetections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch fire danger ratings and total fire ban notifications.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get fire danger and TOBANs
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFireDanger(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfFireDanger>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFireDanger(region, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getFireDanger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get hotspots
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHotspots(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfHotspot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHotspots(region, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getHotspots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch when a fire has likely been ignited.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get fire ignition events
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIgnitions(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfIgnition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIgnitions(region, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getIgnitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get Lightning
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {number} [hours] Hours of strikes to return, 1 to 24; defaults to 3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLightning(region: BfRegionName, simple?: boolean, hours?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfLightning>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLightning(region, simple, hours, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getLightning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve media asserts.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get media
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedia(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedia(region, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get roads
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoads(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfRoad>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoads(region, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getRoads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Time Machine artifacts
         * @param {string} artifact 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeMachineArtifact(artifact: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeMachineArtifact(artifact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getTimeMachineArtifact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get wind forecast
         * @param {BfRegionName} region Region name
         * @param {BfSourceProcess} sourceProcess Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVelocityForecast(region: BfRegionName, sourceProcess: BfSourceProcess, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVelocityForecast(region, sourceProcess, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getVelocityForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get warnings
         * @param {BfRegionName} region Region name
         * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
         * @param {boolean} [simple] Only return simple events
         * @param {string} [definition] Events matching this Notification ID will be returned
         * @param {boolean} [points] If true, only return points (or centroids)
         * @param {boolean} [satelliteDetections] If true, include automated satellite fire detections; defaults to false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarningsIncidents(region: BfRegionName, period?: string, simple?: boolean, definition?: string, points?: boolean, satelliteDetections?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarningsIncidents(region, period, simple, definition, points, satelliteDetections, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getWarningsIncidents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get weather
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeather(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfWeatherObservation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeather(region, simple, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getWeather']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A generic search endpoint which can return warnings, incidents, locations, and users.
         * @summary Search
         * @param {string} query Search query
         * @param {BfRegionName} [region] Region name
         * @param {number} [lat] Proximity latitude
         * @param {number} [lon] Proximity longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(query: string, region?: BfRegionName, lat?: number, lon?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(query, region, lat, lon, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search warnings and incidents
         * @param {string} query Search query
         * @param {BfRegionName} [region] Region name
         * @param {number} [lat] Proximity latitude
         * @param {number} [lon] Proximity longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchWarningsIncidents(query: string, region?: BfRegionName, lat?: number, lon?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchWarningsIncidents(query, region, lat, lon, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.searchWarningsIncidents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload wind data
         * @param {BfSourceProcess} sourceProcess Source process for the wind data
         * @param {File} file File to upload
         * @param {string | null} [orgId] Organisation ID, the icon will be associated with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadWind(sourceProcess: BfSourceProcess, file: File, orgId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadWind(sourceProcess, file, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.uploadWind']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataApi - factory interface
 */
export const DataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataApiFp(configuration)
    return {
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get ADSB
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdsb(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfFlight> {
            return localVarFp.getAdsb(region, simple, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a track for a flight.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get ADSB track
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdsbFlight(eKey: string, options?: RawAxiosRequestConfig): AxiosPromise<FeatureBfFlightSimple> {
            return localVarFp.getAdsbFlight(eKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve automated satellite fire detections and their linked burn areas. These events are excluded from `/warnings` by default.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get satellite detections
         * @param {BfRegionName} region Region name
         * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
         * @param {boolean} [simple] Only return simple events
         * @param {boolean} [points] If true, only return points (or centroids)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetections(region: BfRegionName, period?: string, simple?: boolean, points?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfEvent> {
            return localVarFp.getDetections(region, period, simple, points, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch fire danger ratings and total fire ban notifications.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get fire danger and TOBANs
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFireDanger(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfFireDanger> {
            return localVarFp.getFireDanger(region, simple, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get hotspots
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHotspots(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfHotspot> {
            return localVarFp.getHotspots(region, simple, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch when a fire has likely been ignited.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get fire ignition events
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIgnitions(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfIgnition> {
            return localVarFp.getIgnitions(region, simple, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get Lightning
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {number} [hours] Hours of strikes to return, 1 to 24; defaults to 3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLightning(region: BfRegionName, simple?: boolean, hours?: number, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfLightning> {
            return localVarFp.getLightning(region, simple, hours, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve media asserts.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get media
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedia(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfMedia> {
            return localVarFp.getMedia(region, simple, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get roads
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoads(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfRoad> {
            return localVarFp.getRoads(region, simple, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Time Machine artifacts
         * @param {string} artifact 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeMachineArtifact(artifact: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTimeMachineArtifact(artifact, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get wind forecast
         * @param {BfRegionName} region Region name
         * @param {BfSourceProcess} sourceProcess Source process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVelocityForecast(region: BfRegionName, sourceProcess: BfSourceProcess, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getVelocityForecast(region, sourceProcess, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get warnings
         * @param {BfRegionName} region Region name
         * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
         * @param {boolean} [simple] Only return simple events
         * @param {string} [definition] Events matching this Notification ID will be returned
         * @param {boolean} [points] If true, only return points (or centroids)
         * @param {boolean} [satelliteDetections] If true, include automated satellite fire detections; defaults to false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarningsIncidents(region: BfRegionName, period?: string, simple?: boolean, definition?: string, points?: boolean, satelliteDetections?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfEvent> {
            return localVarFp.getWarningsIncidents(region, period, simple, definition, points, satelliteDetections, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
         * @summary Get weather
         * @param {BfRegionName} region Region name
         * @param {boolean} [simple] Only return simple events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeather(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfWeatherObservation> {
            return localVarFp.getWeather(region, simple, options).then((request) => request(axios, basePath));
        },
        /**
         * A generic search endpoint which can return warnings, incidents, locations, and users.
         * @summary Search
         * @param {string} query Search query
         * @param {BfRegionName} [region] Region name
         * @param {number} [lat] Proximity latitude
         * @param {number} [lon] Proximity longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(query: string, region?: BfRegionName, lat?: number, lon?: number, options?: RawAxiosRequestConfig): AxiosPromise<BfSearchResult> {
            return localVarFp.search(query, region, lat, lon, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search warnings and incidents
         * @param {string} query Search query
         * @param {BfRegionName} [region] Region name
         * @param {number} [lat] Proximity latitude
         * @param {number} [lon] Proximity longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsIncidents(query: string, region?: BfRegionName, lat?: number, lon?: number, options?: RawAxiosRequestConfig): AxiosPromise<BfSearchResult> {
            return localVarFp.searchWarningsIncidents(query, region, lat, lon, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload wind data
         * @param {BfSourceProcess} sourceProcess Source process for the wind data
         * @param {File} file File to upload
         * @param {string | null} [orgId] Organisation ID, the icon will be associated with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWind(sourceProcess: BfSourceProcess, file: File, orgId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadWind(sourceProcess, file, orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataApi - object-oriented interface
 */
export class DataApi extends BaseAPI {
    /**
     * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get ADSB
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdsb(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getAdsb(region, simple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a track for a flight.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get ADSB track
     * @param {string} eKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAdsbFlight(eKey: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getAdsbFlight(eKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve automated satellite fire detections and their linked burn areas. These events are excluded from `/warnings` by default.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get satellite detections
     * @param {BfRegionName} region Region name
     * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
     * @param {boolean} [simple] Only return simple events
     * @param {boolean} [points] If true, only return points (or centroids)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDetections(region: BfRegionName, period?: string, simple?: boolean, points?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getDetections(region, period, simple, points, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch fire danger ratings and total fire ban notifications.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get fire danger and TOBANs
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFireDanger(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getFireDanger(region, simple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get hotspots
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHotspots(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getHotspots(region, simple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch when a fire has likely been ignited.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get fire ignition events
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIgnitions(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getIgnitions(region, simple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get Lightning
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {number} [hours] Hours of strikes to return, 1 to 24; defaults to 3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLightning(region: BfRegionName, simple?: boolean, hours?: number, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getLightning(region, simple, hours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve media asserts.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get media
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMedia(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getMedia(region, simple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get roads
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRoads(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getRoads(region, simple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Time Machine artifacts
     * @param {string} artifact 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTimeMachineArtifact(artifact: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getTimeMachineArtifact(artifact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get wind forecast
     * @param {BfRegionName} region Region name
     * @param {BfSourceProcess} sourceProcess Source process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVelocityForecast(region: BfRegionName, sourceProcess: BfSourceProcess, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getVelocityForecast(region, sourceProcess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get warnings
     * @param {BfRegionName} region Region name
     * @param {string} [period] Optional historic period to fetch (ISO8601 - 2024-04-01T00:00:00Z), if not present, fetch latest
     * @param {boolean} [simple] Only return simple events
     * @param {string} [definition] Events matching this Notification ID will be returned
     * @param {boolean} [points] If true, only return points (or centroids)
     * @param {boolean} [satelliteDetections] If true, include automated satellite fire detections; defaults to false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWarningsIncidents(region: BfRegionName, period?: string, simple?: boolean, definition?: string, points?: boolean, satelliteDetections?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getWarningsIncidents(region, period, simple, definition, points, satelliteDetections, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a data asset.  See: See licence and permitted usages https://developers.bushfire.io/api#overview.
     * @summary Get weather
     * @param {BfRegionName} region Region name
     * @param {boolean} [simple] Only return simple events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWeather(region: BfRegionName, simple?: boolean, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getWeather(region, simple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A generic search endpoint which can return warnings, incidents, locations, and users.
     * @summary Search
     * @param {string} query Search query
     * @param {BfRegionName} [region] Region name
     * @param {number} [lat] Proximity latitude
     * @param {number} [lon] Proximity longitude
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public search(query: string, region?: BfRegionName, lat?: number, lon?: number, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).search(query, region, lat, lon, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search warnings and incidents
     * @param {string} query Search query
     * @param {BfRegionName} [region] Region name
     * @param {number} [lat] Proximity latitude
     * @param {number} [lon] Proximity longitude
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchWarningsIncidents(query: string, region?: BfRegionName, lat?: number, lon?: number, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).searchWarningsIncidents(query, region, lat, lon, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload wind data
     * @param {BfSourceProcess} sourceProcess Source process for the wind data
     * @param {File} file File to upload
     * @param {string | null} [orgId] Organisation ID, the icon will be associated with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadWind(sourceProcess: BfSourceProcess, file: File, orgId?: string | null, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).uploadWind(sourceProcess, file, orgId, options).then((request) => request(this.axios, this.basePath));
    }
}

